import { apiClient } from '~/api/client';

export type SupportFeatureFlagOption = {
  name: string;
  label: string;
};

type FeatureFlagsResponse = {
  feature_flags: SupportFeatureFlagOption[];
};

export const index = async () => apiClient.get<FeatureFlagsResponse>('/support/feature_flags');
